import type { Theme } from '../themeTypes'
import type { TokenPath } from './generated/types'

interface TokenTree {
  [key: string]: string | TokenTree
}

const walkTokenPath = (tree: TokenTree, segments: string[]): string => {
  let current: string | TokenTree = tree

  for (const segment of segments) {
    if (typeof current !== 'object' || current == null || !(segment in current)) {
      throw new Error(`Token path not found: ${segments.join('.')}`)
    }

    current = current[segment]
  }

  if (typeof current !== 'string') {
    throw new TypeError(`Token path does not resolve to a color: ${segments.join('.')}`)
  }

  return current
}

export const getToken = <T extends TokenPath>(theme: Theme, path: T): string => {
  const segments = path.split('.')
  return walkTokenPath(theme.tokens as unknown as TokenTree, segments)
}
